import script from "./PlanetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanetModal.vue?vue&type=script&setup=true&lang=js"

import "./PlanetModal.vue?vue&type=style&index=0&id=721b9152&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721b9152"]])

export default __exports__